/**
 * TanStack Query hooks for `igaming-win-loss-events`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingWinLossEventsQueryKeys,
	type CreateIgamingWinLossEventsBody,
	type ListIgamingWinLossEventsResponse,
	type IgamingWinLossEventsRow,
} from "./api";

export function useIgamingWinLossEventsList(): UseQueryResult<ListIgamingWinLossEventsResponse, Error> {
	return useQuery({
		queryKey: igamingWinLossEventsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingWinLossEventsCreate(): UseMutationResult<IgamingWinLossEventsRow, Error, CreateIgamingWinLossEventsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWinLossEventsQueryKeys.all });
		},
	});
}

export function useIgamingWinLossEventsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWinLossEventsQueryKeys.all });
		},
	});
}
